var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"slot-activator",on:{"click":function($event){return _vm.launchFilePicker()}}},[_vm._t("activator")],2),_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","name":_vm.uploadFieldName},on:{"change":function($event){return _vm.onFileChange($event.target.name, $event.target.files)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }